module.exports = __webpack_public_path__ + "img/pib-black@2x.3a666873.png";